<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

  		<div class="layoutTop"/>

      <!-- TODO -->
      <f7-list form>
        <f7-list-item>
          <f7-label>Group name</f7-label>
          <f7-input name="groupName" placeholder="Group Name" type="text" v-model="groupName"></f7-input>
        </f7-list-item>
        <f7-list-item>
            <div class="item-title">Service {{nameService }}</div>
            <div class="item-after">
              <div class="item-input">
                <label class="label-switch">
                  <input type="checkbox" class="checkService" @change="changeService" v-bind:value="serviceActif">
                  <div class="checkbox"></div>
                </label>
              </div>
            </div>
        </f7-list-item>
        <!-- TODO old version -->
        <f7-list-item>
          <div class="test-title subtitleDebtorList">Members</div>
          <div class="test-after"><a href="/accountMembers/addMemberGroupMembersList/"><span href="#" class="button button-round orangeBackground">{{ this.selected.length }} selected</span></a></div>
        </f7-list-item>
      </f7-list>

      <div class="contactGroupTitle" v-if="Object.keys(this.selectedAccounts).length > 0">Members in this group</div>

      <f7-list v-if="Object.keys(this.selectedAccounts).length !== 0">
        <f7-list-item v-for="value in this.selectedAccounts" v-bind:key="value.id" v-bind:title="value.login"></f7-list-item>
      </f7-list>

      <f7-button
        round
        class="orangeConfirmationButton firstButtonMarginTop"
        :title="$t('common.negot')"
        @click="changeMemberGroup">
        Save
      </f7-button>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      accounts: [],
      membersObject: {},
      memberSelectionList: [],
      selectedAccounts: {},
      selected: [],
      memberGroupId: '',
      groupName: '',
      serviceActif: false,
      nameService: ''
    }
  },
  mounted () {
    this.serviceActif = this.$settings.currentMemberGroup.actif === '1'
    this.nameService = this.$engine.firstOn().user.currentService.name
    if (this.serviceActif) {
      this.Dom7('.checkService').prop('checked', true)
    }
  },
  created () {
    let that = this
    this.accounts = this.$settings.currentAccount.userAccts
    for (var i = 0; i < that.accounts.length; i++) {
      that.membersObject[that.accounts[i].id] = that.accounts[i]
    }
    this.setMembers()

    this.memberGroupId = this.$settings.currentMemberGroup.id
    this.groupName = this.$settings.currentMemberGroup.label
    this.selected = this.$settings.currentMemberGroup.members

    this.changeItem()

    that.$engine.firstOn().settings.set({addMemberGroupMemberSelected: this.selected})

    this.$bus.$on('refresh-add-member-group-member-selected', (data) => {
      that.selected = data
      that.changeItem()
    })
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    changeItem () {
      this.selectedAccounts = {}
      for (var i = 0; i < this.selected.length; i++) {
        this.selectedAccounts[this.selected[i]] = this.membersObject[this.selected[i]]
      }
    },
    setMembers: function () {
      var memberList = {}
      let that = this
      for (var i = 0; i < this.$settings.currentAccount.userAccts.length; i++) {
        var firstLetter = this.$settings.currentAccount.userAccts[i].login.substr(0, 1).toUpperCase()
        if (!memberList.hasOwnProperty(firstLetter)) {
          memberList[firstLetter] = []
        }
        memberList[firstLetter].push({login: that.$settings.currentAccount.userAccts[i].login, name: that.$settings.currentAccount.userAccts[i].name, id: that.$settings.currentAccount.userAccts[i].id, clearance_payments: that.$settings.currentAccount.userAccts[i]['Payments'], clearance_directDebit: that.$settings.currentAccount.userAccts[i]['Direct Debit'], clearance_directPayments: that.$settings.currentAccount.userAccts[i]['Direct Payments']})
        memberList[firstLetter].sort()
      }
      this.memberSelectionList = this.orderKeys(memberList)
    },
    changeService (obj) {
      this.serviceActif = obj.target.checked
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })

      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }

      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeMemberGroup () {
      let that = this
      let serviceActifValue = this.serviceActif === true ? '1' : '0'
      if (that.groupName !== '' && that.selected.length > 0) {
        this.$engine.firstOn().accounts.updateGroup({
          idGroup: this.memberGroupId,
          label: this.groupName,
          service: this.$engine.firstOn().user.currentService.id,
          actif: serviceActifValue,
          accounts: this.selected
        })
        .then(() => {
          that.$f7.modal({
            title: 'Group modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.memberGroupId = ''
            that.groupName = ''
            that.selected = []
            that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
        this.$f7.closeModal()
      } else {
        this.$f7.alert('', 'Data empty')
      }
    }
  }
}
</script>
